import { getIssuer } from 'modules/creditCard';
import { MASK } from 'modules/paymentMethod/describePaymentMethod';
import useBillingPaymentMake from 'modules/queries/billing/payment/useMake';
import { useDialogMakePaymentContext } from '../dialogMakePaymentContext';
import ConfirmPaymentContent from './ConfirmPayment';

/** Confirms a payment on a card just entered through Accept.js */
const ConfirmNewAuthNetPayment = () => {
	const {
		accountBalanceDisplay,
		formValues,
		opaqueData,
		onSubmitSuccess,
		onSubmitError,
	} = useDialogMakePaymentContext();
	const { mutate: makePayment, isLoading: isMakingPayment } =
		useBillingPaymentMake();

	const { amount, cardNumber } = formValues;
	const issuer = getIssuer(cardNumber) || '';
	const label = `${MASK} ${cardNumber.slice(-4)}`;

	const handleSubmit = () => {
		if (!opaqueData) {
			// should never happen but just in case...
			onSubmitError();
			return;
		}

		makePayment(
			{
				amount,
				opaque_data: opaqueData,
			},
			{
				onSuccess: onSubmitSuccess,
				onError: onSubmitError,
			},
		);
	};

	return (
		<ConfirmPaymentContent
			accountBalance={Number(accountBalanceDisplay)}
			amount={Number(amount)}
			paymentMethod="credit_card"
			onSubmit={handleSubmit}
			issuer={issuer}
			label={label}
			isSubmitting={isMakingPayment}
		/>
	);
};

export default ConfirmNewAuthNetPayment;
